import { AdvisorPrefixes, INVESTOR_ACCREDITED, INVESTOR_NON_ACCREDITED } from 'const/types'

export * from './user-hooks'

function unflattenToUserObject(flatUser) {
  return Object.entries(flatUser).reduce((acc, [key, value]) => {
    const prefix = AdvisorPrefixes.find(
      (p) => key.startsWith(p) && key[p.length] === key[p.length]?.toUpperCase(),
    )

    if (prefix) {
      const prop = key.slice(prefix.length)
      const nestedKey = prop[0].toLowerCase() + prop.slice(1)
      acc[prefix] = { ...(acc[prefix] || {}), [nestedKey]: value }
    } else {
      acc[key] = value
    }

    return acc
  }, {})
}

function flattenToUserObject(user, prefixesToFlatten = AdvisorPrefixes) {
  const flattened = { ...user }

  prefixesToFlatten.forEach((nestedKey) => {
    const nestedObject = user[nestedKey]
    if (typeof nestedObject === 'object' && nestedObject !== null) {
      Object.entries(nestedObject).forEach(([key, value]) => {
        const flatKey = `${nestedKey}${key.charAt(0).toUpperCase()}${key.slice(1)}`
        flattened[flatKey] = value
      })
    }
    delete flattened[nestedKey]
  })

  return flattened
}
export const fromServerData = (user) => {
  const flatUser = flattenToUserObject(user)
  return {
    ...flatUser,
    _accredited: flatUser.accredited ? INVESTOR_ACCREDITED : INVESTOR_NON_ACCREDITED,
  }
}

export const toServerData = ({ _resident, _accredited, _isJoint, jointType, ...data }) => ({
  ...unflattenToUserObject(data),
  accredited: _accredited === INVESTOR_ACCREDITED,
})

export const parseError = (key) => {
  const prefix = AdvisorPrefixes.find(
    (p) => key.startsWith(p) && key[p.length] === key[p.length]?.toUpperCase(),
  )
  if (prefix) {
    const [_, suf] = key.split('.')
    return suf ? `${prefix}${suf.charAt(0).toUpperCase()}${suf.slice(1)}` : undefined
  }
}

export const toServerDataRegister = (data) => unflattenToUserObject(data)
